import React, {useState, useEffect} from 'react';
import './FooterTop.css';
import geoHerb from "./herbbetter.png"
import {useTranslation} from "react-i18next";
import {ContactMap} from "../../ContactMap/ContactMap";
import ContactComponent from "./ContactComponent";
import InfoComponent from "./RowComponent";
import axios from "axios";

function FooterTop() {
    const {t, i18n} = useTranslation();
    const [pageName, setPageName] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [rowsData, setRowsData] = useState([]);
    const textKeys = [
        "საქართველოს ეკონომიკისა და",
        "მდგრადი განვითარების სამინისტროს",
        "სსიპ ტექნიკური და სამშენებლო",
        "ზედამხედველობის სააგენტოო"
    ];

    useEffect(() => {
        setIsLoading(true);
        const fetchFooterData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageFooter`);
                if (response.data.success) {
                    const filtered = response.data.data.filter(item => !item.isTemplate);
                    processFooterData(filtered);
                }
            } catch (error) {
                console.error("Error fetching footer data:", error);
            } finally {
                setTimeout(() => setIsLoading(false), 500);
            }
        };


        void fetchFooterData();
    }, [i18n.language]);


    const processFooterData = (data) => {
        const groupedData = data.reduce((acc, item) => {
            const groupName =
                i18n.language === 'geo'
                    ? item.groupName
                    : item.groupNameEng || item.groupName;
            const group = acc[groupName] || [];
            group.push({
                to: `/pages/${item.url}`,
                text:
                    i18n.language === 'geo'
                        ? item.name
                        : item.nameEng || item.name,
                sort: item.sort
            });
            acc[groupName] = group;
            return acc;
        }, {});

        const formattedRows = Object.keys(groupedData).map((groupName) => ({
            title: groupName,
            links: groupedData[groupName].sort((a, b) => a.sort - b.sort)
        }));

        setRowsData(formattedRows);
    };



    useEffect(() => {
        const pathname = window.location.pathname;
        const pageNameFromPath = pathname.split('/').filter(Boolean).pop() || 'home';
        setPageName(pageNameFromPath);
    }, [pageName]);


    if (isLoading) {
        return (
            <div className="footer-container-loader">
                <div className="spinner"></div>
            </div>
        );
    }


    return (
        <div className="footer-container">

            <div className="footer-text">
                <div className={"company-name"}>
                    <div style={{marginTop: 70}} className="footer-logo">
                        <img className="main-logo" src={geoHerb} alt="Logo"/>
                    </div>
                    <div style={{marginTop: 15}}>
                        {textKeys.map((key, index) => (
                            <div className="economic-title" key={index}>{t(key)}</div>
                        ))}
                    </div>
                </div>
                {rowsData.length !== 0 && (
                    <InfoComponent rowsData={rowsData}/>
                )}
            </div>
            <div className={"contact-container"}>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.google.com/maps/place/LEPL+Technical+and+Construction+Supervision+Agency/@41.7200275,44.713523,15z/data=!4m2!3m1!1s0x0:0x736507bdf1364e8f?sa=X&ved=2ahUKEwiO5MPtnvWCAxWwZ_EDHWGMCVQQ_BJ6BAgJEAA"
                >
                    <ContactMap/>
                </a>
                <ContactComponent/>

            </div>
        </div>
    );
}

export default FooterTop;
